import { render, staticRenderFns } from "./quickAddCourseCtr.vue?vue&type=template&id=c3e25fae&scoped=true"
import script from "./quickAddCourseCtr.vue?vue&type=script&lang=js"
export * from "./quickAddCourseCtr.vue?vue&type=script&lang=js"
import style0 from "./quickAddCourseCtr.vue?vue&type=style&index=0&id=c3e25fae&prod&lang=less"
import style1 from "./quickAddCourseCtr.vue?vue&type=style&index=1&id=c3e25fae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e25fae",
  null
  
)

export default component.exports